import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { TranslateModule } from '@ngx-translate/core'

import { BOOTSTRAP_PROVIDERS } from './providers/bootstrap-provider'
import { AUTH_INTERCEPTOR } from './providers/auth-interceptor.provider'
import { ENCODE_HTTP_PARAMS_INTERCEPTOR } from './providers/encode-http-params.provider'
import { FORM_FEEDBACK_INTERCEPTOR } from './providers/form-feedback-interceptor.provider'
import { TRANSLATE_LOADER } from './providers/translate-loader.provider'
import { ERROR_HANLDER_PROVIDER } from './providers/error-hanlder.provider'

import { SnackBarModule } from './modules/snack-bar/snack-bar.module'
import { NavbarModule } from './modules/navbar/navbar.module'
import { SidebarModule } from './modules/sidebar/sidebar.module'
import { ToolbarModule } from './modules/toolbar/toolbar.module'
import { ContentModule } from './modules/content/content.module'
import { MaterialModule } from '@shared/material/material.module'

import { PageNotFoundComponent } from './components/page-not-found/page-not-found.component'
import { BlockedUserComponent } from './components/blocked-user/blocked-user.component'
import { PageFatalErrorComponent } from './components/page-fatal-error/page-fatal-error.component'

@NgModule({
  declarations: [PageNotFoundComponent, BlockedUserComponent, PageFatalErrorComponent],
  imports: [
    CommonModule,
    TranslateModule.forRoot(),
    SnackBarModule,
    NavbarModule,
    SidebarModule,
    ToolbarModule,
    ContentModule,
    MaterialModule,
  ],
  exports: [TranslateModule, NavbarModule, SidebarModule, ToolbarModule, ContentModule],
  providers: [
    ...BOOTSTRAP_PROVIDERS,
    ...TRANSLATE_LOADER,
    AUTH_INTERCEPTOR,
    ENCODE_HTTP_PARAMS_INTERCEPTOR,
    FORM_FEEDBACK_INTERCEPTOR,
    ERROR_HANLDER_PROVIDER,
  ],
})
export class CoreModule {}
